export default __webpack_public_path__ + "static/media/37t.e4d0c72d.jpg";